import { tm } from '../../tm'
import type { Project } from '@captaincause/types'

interface AssociationNameProps {
  project: Project
  className?: string
}

export function AssociationName({
  project,
  className = '',
}: AssociationNameProps) {
  return (
    <div className={tm('flex w-full items-center space-x-3', className)}>
      <div className="h-9 w-9 min-w-[32px] items-center justify-center overflow-hidden rounded-full bg-white p-1">
        <img
          src={project.organization.logo}
          alt="logo"
          width={32}
          height={32}
          className="h-full w-full object-contain"
        />
      </div>
      <span className="pr-[100px] text-sm font-medium leading-5 -tracking-[0.14px] text-white">
        {project.organization.name}
      </span>
    </div>
  )
}
